module.exports = __webpack_public_path__ + "static/media/click3.a923ce2d.aac";